import { render, staticRenderFns } from "./HeroBannerCarouselDesktop.vue?vue&type=template&id=3bff047e&scoped=true&lang=pug&"
import script from "./HeroBannerCarouselDesktop.vue?vue&type=script&lang=js&"
export * from "./HeroBannerCarouselDesktop.vue?vue&type=script&lang=js&"
import style0 from "./HeroBannerCarouselDesktop.vue?vue&type=style&index=0&id=3bff047e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bff047e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bff047e')) {
      api.createRecord('3bff047e', component.options)
    } else {
      api.reload('3bff047e', component.options)
    }
    module.hot.accept("./HeroBannerCarouselDesktop.vue?vue&type=template&id=3bff047e&scoped=true&lang=pug&", function () {
      api.rerender('3bff047e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/sections/HeroBannerCarouselDesktop.vue"
export default component.exports